import { createPinia } from 'pinia'

// shared instance to be used in all vue apps
// Vue.use(PiniaVuePlugin) happens in app.js
export const pinia = createPinia()
